// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scroll-menu-view{top:2.700625rem;z-index:90;background:#f2f2f2}.scroll-menu-view .ly-tab-item{font-size:1.125rem}", ""]);
// Exports
module.exports = exports;
